export const DATA_TEST_IDS = {
  ORG_MAIL_LINK: 'org-mail-link',
  ORG_NAME_TEXT: 'org-name-text',
  ORG_NAME_TITLE: 'org-name-title',
  ORG_LOGO_WITH_TRENTIAL: 'org-logo-with-trential',
  ORG_LOGO_LOGIN_FORM: 'org-logo-login-form',
  ORG_SPECIFIC_BANNER: 'org-specific-banner',
  SPINNER_LOGO: 'spinner-logo',
  ORG_PARTNER_WEBSITE_LINK: 'org-partner-website-link',
  ORG_WEBSITE_LINK: 'org-website-link',
  DEMO_VIDEO_SOURCE: 'demo-video-source',
  COMPANY_DEFINITION: 'company-definition',
  WEBSITE_DEFINITION: 'website-definition',
  ORG_FULL_NAME_TEXT: 'org-full-name-text',
  CONSENT_TEXT: 'consent-text',
  TNC_ORG_FULL_NAME: 'tnc-org-full-name',
  TNC_ORG_ALTERNATE_NAME: 'tnc-org-alternate-name',
  TNC_ORG_MAIL: 'tnc-org-mail',
  SUPPORT_CONTACT_TEXT: 'support-contact-text',
  ORG_MAIL_TEXT: 'org-mail-text',
  CONTACT_PHONE_TEXT: 'contact-phone-text',
  CONTACT_PHONE_TEXT_MOBILE: 'contact-phone-text-mobile',
  DISCOUNT_VALUE: 'discount-value',
  INSTRUCTION_DESC_WITH_ORG: 'instruction-desc-with-org',
  ORG_ALTERNATE_NAME_TEXT: 'org-alternate-name-text'
};
